import React from 'react';
import { FiDownload } from 'react-icons/fi';
import ActionButton from './ActionButton';

const DownloadButton = ({ onClick, title = "Download", className = "" }) => {
  return (
    <ActionButton
      icon={FiDownload}
      onClick={onClick}
      title={title}
      className={className}
    />
  );
};

export default DownloadButton;
